import React, { forwardRef } from 'react';

import { getClassNames } from './Flex.styles';
import { FlexProps } from './Flex.types';

const Flex = forwardRef<HTMLDivElement, FlexProps>(({ children, ariaHidden, role, ...styleProps }, ref) => (
  <div className={getClassNames(styleProps).flex} role={role} aria-hidden={ariaHidden} ref={ref}>
    {children}
  </div>
));

Flex.displayName = 'Flex';

/**
 * A `Flex` component renders a flex-parent div with common flex-container styles.
 */
export default Flex;
